import "picturefill";

// Picturefill 実行
if (window.picturefill) {
  window.picturefill();
}
